import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import CollectionView from "./components/CollectionView";
import Search from "./routes/Search";
import Bookmarks from "./routes/Bookmarks";
import { AssessmentDetails } from "Assessments";
import UnitPlanDetails from "UnitPlanDetails/index.v2";
import { injectReducer } from "store/reducers";
import WorksheetView from "./routes/WorksheetView";
import QuestionView from "./routes/QuestionView";
import FeedSection from "./routes/FeedSection";
export default store => {
  return {
    path: "toddle-library",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "toddle-library" */ "./components"),
          import(
            /* webpackChunkName: "toddle-library" */ "ToddleLibrary/modules/ToddleLibraryModule"
          ),
          import(
            /* webpackChunkName: "toddle-library" */ "ClassRoom/modules/ClassRoomModule"
          ),
          import(
            /* webpackChunkName: "toddle-library" */ "UnitPlans/modules/UnitPlanModule"
          ),
          import(
            /* webpackChunkName: "toddle-library" */ "Assessments/modules/AssessmentModule"
          ),
          import(
            /* webpackChunkName: "toddle-library" */ "AppComponents/LEIntoUnitImport/modules/Module"
          ),
          import(
            /* webpackChunkName: "toddle-library" */ "Worksheet/modules/WorksheetModules"
          ),
          import(
            /* webpackChunkName: "toddle-library" */ "Platform/modules/PlatformModule"
          ),
        ]).then(
          ([
            importedModule0,
            importedModule1,
            importedModule2,
            importedModule3,
            importedModule4,
            importedModule5,
            importedModule6,
            importedModule7,
          ]) => {
            const component = importedModule0.default;
            const reducer = importedModule1.default;
            const classRoomReducer = importedModule2.default;
            const unitPlanModule = importedModule3.default;
            const assessmentModule = importedModule4;
            const LEIntoUnitImportModule = importedModule5;
            const worksheetModule = importedModule6;
            const platformReducer = importedModule7.default;
            injectReducer(store, {
              key: "toddleLibrary",
              reducer,
            });
            injectReducer(store, {
              key: "classRoom",
              reducer: classRoomReducer,
            });
            injectReducer(store, {
              key: "unitPlans",
              reducer: unitPlanModule,
            });
            injectReducer(store, {
              key: assessmentModule.NAME,
              reducer: assessmentModule.default,
            });
            injectReducer(store, {
              key: LEIntoUnitImportModule.NAME,
              reducer: LEIntoUnitImportModule.default,
            });
            injectReducer(store, {
              key: worksheetModule.NAME,
              reducer: worksheetModule.default,
            });
            injectReducer(store, {
              key: "platform",
              reducer: platformReducer,
            });
            return component;
          }
        )
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [
      FeedSection(store),
      AssessmentDetails(store),
      UnitPlanDetails(store),
      CollectionView(store),
      Search(store),
      Bookmarks(store),
      WorksheetView(store),
      QuestionView(store),
    ],
  };
};
